
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useAuthState } from '../../../../../../Helper/Context';
import { RegExOnlyText } from '../../../../../../Helper/regEx/RegExOnlyText';
import { AstricSign } from '../../../../../../Helper/AstricSign';
import { WorkNameDDL } from '../../../../../../Components/CommonDDL/WorkNameDDL';
import { DummyDDL } from '../../../../../../Components/CommonDDL/DummyDDL';
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL';
import { LocationDDL } from '../../../../../../Components/CommonDDL/LocationDDL';
import { PillerDDL } from '../../../../../../Components/CommonDDL/PillerDDL';
import { PoleEleMasterPostDataAPI } from '../../../../../../Redux/ElectricalSlice/PoleSlice';


export default function AddElectricPolePopUp(props) {

    const { item, EditIcon, Flag, handleIsPost, rowData, open, handleOnCloseClick } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();

    // const [rowData, setRowData] = useState(Flag === 'Update' ? item : '')
    // console.log('DashboardName ##################', rowData)

    const [PoleNumber, setPoleNumber] = useState(Flag == 'Update' ? rowData.poleCount : '')

    const [Isloading, setIsloading] = useState(false)
    const [IsPost, setIsPost] = useState(false)

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const [LocationName, setLocationName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [PillerID, setPillerID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    const handlePost = () => {
        const data = {
            M_ELEC_PoleID : 0,
            M_WardID : WardName?.ID,
            M_ELEC_LocationID : LocationName?.ID,
            M_ELEC_PillerID : PillerID?.ID,
            PoleNumber : PoleNumber,
            AreaName : '',
            Photo :null,
            Latitude :null,
            Longitude :null,
            M_UserID : UserID,
            Flag : Flag,
            token : token,
            setLoading : setIsloading,
            handleIsPost : handleIsPost,
            handleOnCloseClick : handleOnCloseClick
        }
        dispatch(PoleEleMasterPostDataAPI({ data }))
    }

    return (


        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h5 className="modal-title pt-1" id="staticBackdropLabel">{Flag === "Update" ? "Update" : "Add"} Pole</h5>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row col-12 ">

                                <div className="col-12">
                                    <div className="form-group">
                                        <WardNameDataDDL
                                            WardName={WardName}
                                            setWardName={setWardName}
                                            HWard='0'
                                            WLable=''
                                            Type="Electrical"
                                            APIFlag="Master"
                                            IsPost={IsPost}
                                            rowData={rowData}
                                            Flag={Flag}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <LocationDDL
                                            WardName={WardName}
                                            LocationName={LocationName}
                                            setLocationName={setLocationName}
                                            APIFlag="Master"
                                            IsPost={IsPost}
                                            rowData={rowData}
                                            Flag={Flag}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <PillerDDL
                                            PillerID={PillerID}
                                            setPillerID={setPillerID}
                                            WardName={WardName}
                                            LocationName={LocationName}
                                            APIFlag="Master"
                                            IsPost={IsPost}
                                            rowData={rowData}
                                            Flag={Flag}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Pole Count</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="PoleNumber"
                                            value={PoleNumber}
                                            onChange={(e) => setPoleNumber(e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* <div className="col-12">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Pole Count</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="DesignationName"
                                            // value={DesignationName}                                          
                                            value={DesignationName}
                                            // onChange={(e) => handleCheckText(e)}
                                            onChange={(e) => setDesignationName(e.target.value)}
                                        />
                                    </div>
                                </div> */}

                            </div>

                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            PoleNumber == '' || WardName?.ID == 0 || LocationName?.ID == 0 || PillerID?.ID == 0
                                        }
                                    >{Flag === "Update" ? "Update" : "Add"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}